var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReplaySubject } from 'rxjs';
import { HighLevelRequest, InstrumentFieldValueRequest, NotationFieldValueRequest, ErrorResponse, isErrorResponse, isPermissionDeniedResponse, isRejectResponse } from '../message';
import { MessageFactory } from '../message/MessageFactory';
import { AuthenticationTokenRequest } from '../message/request/AuthenticationTokenRequest';
import { PrioritizedInstrumentFieldValueRequest } from '../message/request/PrioritizedInstrumentFieldValueRequest';
import { PrioritizedNotationFieldValueRequest } from '../message/request/PrioritizedNotationFieldValueRequest';
import { TransportLayerClientRequestHeader } from '../message/request/util/TransportLayerClientRequestHeader';
import { CookieTokenAuthenticationFactors } from '../authentication';
import { TimeoutWrapper } from '../util/TimeOutWrapper';
import { HTTPProxyRequest } from '../message/request/HTTPProxyRequest';
var RequestModule = (function () {
    function RequestModule(client) {
        this.bufferSize = 512;
        this.rejectResponsesTimeout = [50, 100, 200, 400, 800, 1600, 3200];
        this.TimeoutErrorMessage = 'Request timeout reached';
        this.client = client;
        this.requestSubject = new ReplaySubject(this.bufferSize);
        this.jobs = new Map();
        this.logger = this.client.getLogger();
    }
    RequestModule.prototype.setLogger = function (logger) {
        this.logger = logger;
    };
    RequestModule.prototype.reset = function () {
        this.requestSubject.complete();
        this.requestSubject = new ReplaySubject(this.bufferSize);
    };
    RequestModule.prototype.requestWithQuality = function (msg, quality, timeOutInMs) {
        if (quality === 'BST') {
            return this.requestBestQuality(msg);
        }
        if (quality && Object.keys(TransportLayerClientRequestHeader.PRICE_QUALITY).includes(quality)) {
            msg.header.setQuality(quality);
        }
        timeOutInMs && msg.header.setTimeout(timeOutInMs);
        return this.request(msg, timeOutInMs);
    };
    RequestModule.prototype.requestEndpoint = function (method, path, data, options, timeOutInMs) {
        return __awaiter(this, void 0, void 0, function () {
            var highLevelRequest, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        highLevelRequest = new HighLevelRequest(method, path, data, options);
                        return [4, this.request(highLevelRequest, timeOutInMs)];
                    case 1:
                        response = _a.sent();
                        this.logger.info("Endpoint Response: [" + method + "] " + path, { request: data, response: response.data });
                        return [2, { response: response, data: response.data }];
                }
            });
        });
    };
    RequestModule.prototype.requestProxyEndpoint = function (method, path, body, options, timeOutInMs) {
        return __awaiter(this, void 0, void 0, function () {
            var httpProxyRequest, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpProxyRequest = new HTTPProxyRequest(method, path, options);
                        if (body) {
                            httpProxyRequest.setBody(body);
                        }
                        return [4, this.request(httpProxyRequest, timeOutInMs)];
                    case 1:
                        response = _a.sent();
                        this.logger.info("Endpoint Response: [" + method + "] " + path, { request: body, response: response.data });
                        return [2, { response: response, data: response.data }];
                }
            });
        });
    };
    RequestModule.prototype.requestAuthenticationToken = function (lifetimeSeconds, idUser, idApplication) {
        return __awaiter(this, void 0, void 0, function () {
            var authenticationTokenRequest, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authenticationTokenRequest = new AuthenticationTokenRequest(lifetimeSeconds);
                        if (idUser) {
                            authenticationTokenRequest.header.setIdUser(idUser);
                        }
                        if (idApplication) {
                            authenticationTokenRequest.header.setIdApplication(idApplication);
                        }
                        return [4, this.request(authenticationTokenRequest)];
                    case 1:
                        response = _a.sent();
                        return [2, response.getToken()];
                }
            });
        });
    };
    RequestModule.prototype.requestAuthenticationTokenFactorsForCookieAuthentication = function (lifetimeSeconds, idUser, idApplication) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.requestAuthenticationToken(lifetimeSeconds, idUser, idApplication)];
                    case 1:
                        token = _a.sent();
                        return [2, new CookieTokenAuthenticationFactors(token)];
                }
            });
        });
    };
    RequestModule.prototype.onConnection = function () {
        this.client.getConnection().onMessage = this.handleMessage.bind(this);
        this.requestSubject.subscribe(this.sendRequest.bind(this));
    };
    RequestModule.prototype.setUpdateMessageHandler = function (handler) {
        this.updateMessageHandler = handler;
    };
    RequestModule.prototype.setLossMessageHandler = function (handler) {
        this.lossMessageHandler = handler;
    };
    RequestModule.prototype.request = function (msg, timeOutInMs) {
        var _this = this;
        if (RequestModule.supportedPermissionDeniedResponseMessages(msg) && this.client.flagPermissionDenied) {
            msg.header.setFlag('permission_denied_response');
        }
        if (timeOutInMs) {
            msg.header.setTimeout(timeOutInMs);
            return TimeoutWrapper.wrap(new Promise(function (resolve, reject) { return _this.requestSubject.next({ msg: msg, insertedAt: Date.now(), resolve: resolve, reject: reject }); }), timeOutInMs, this.TimeoutErrorMessage);
        }
        else {
            return new Promise(function (resolve, reject) { return _this.requestSubject.next({ msg: msg, insertedAt: Date.now(), resolve: resolve, reject: reject }); });
        }
    };
    RequestModule.prototype.reRequest = function (job) {
        this.requestSubject.next({ msg: job.msg, resolve: job.resolve, reject: job.reject });
    };
    RequestModule.prototype.requestBestQuality = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var orderedPriceQuality, i, promise, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderedPriceQuality = ['RLT', 'DLY', 'EOD'];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < orderedPriceQuality.length)) return [3, 7];
                        msg.header.setQuality(orderedPriceQuality[i]);
                        promise = this.request(msg);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, promise];
                    case 3:
                        _a.sent();
                        return [2, promise];
                    case 4:
                        err_1 = _a.sent();
                        this.logger.debug("Failed to perform request in \"" + orderedPriceQuality[i] + "\" quality.", err_1, msg);
                        return [3, 5];
                    case 5:
                        if (i === (orderedPriceQuality.length - 1)) {
                            return [2, promise];
                        }
                        _a.label = 6;
                    case 6:
                        i++;
                        return [3, 1];
                    case 7: return [2];
                }
            });
        });
    };
    RequestModule.prototype.handleMessage = function (rawMessage) {
        var msg;
        try {
            msg = MessageFactory.createMessage(rawMessage);
        }
        catch (createMessageError) {
            this.logger.error('Problem while creating message', createMessageError);
            return;
        }
        var jobId = msg.jobId;
        var job = this.jobs.get(jobId);
        if (msg.isUpdateMessage() && this.updateMessageHandler) {
            this.updateMessageHandler(msg, jobId);
            return;
        }
        if (msg.isLossMessage() && this.lossMessageHandler) {
            this.lossMessageHandler(msg, jobId);
            this.jobs.delete(jobId);
            return;
        }
        if (!job) {
            this.logger.error("Could not find idJob " + jobId, rawMessage);
            return;
        }
        if (isRejectResponse(msg)) {
            this.logger.debug("RejectResponse received for idJob " + jobId, rawMessage);
            this.rejectResponseHandler(job);
            return;
        }
        if (isErrorResponse(msg) || isPermissionDeniedResponse(msg)) {
            var debugObject = {
                request: job.request,
                response: msg
            };
            this.logger.warn("Received " + msg.name + " with idJob: " + jobId, debugObject);
            job.reject(msg);
            this.jobs.delete(jobId);
            return;
        }
        this.logger.trace("Received " + msg.name + " with idJob: " + jobId, msg);
        this.jobs.delete(jobId);
        job.resolve(msg);
    };
    RequestModule.prototype.rejectResponseHandler = function (job) {
        var _this = this;
        var rejectResponseTimeout = this.getRejectResponseTimeout(job.msg.header.getResendCounter());
        var calculatedTimeout = (job.expirationTime - Date.now()) - rejectResponseTimeout;
        if (calculatedTimeout < 1) {
            var errorMessage = "Timeout for idJob " + job.msg.header.getJobId();
            this.logger.error(errorMessage);
            return job.reject(new ErrorResponse({
                Message: 'Foundation:ErrorResponse',
                Version: 1,
                id_job: job.msg.header.getJobId(),
                reason: 8,
                details: errorMessage
            }));
        }
        this.logger.debug("Retry request after " + rejectResponseTimeout + "ms for idJob " + job.msg.header.getJobId());
        setTimeout(function () {
            job.msg.header.setTimeout(calculatedTimeout);
            job.msg.header.countResend();
            return _this.reRequest(job);
        }, rejectResponseTimeout);
    };
    RequestModule.prototype.getRejectResponseTimeout = function (resendCounter) {
        if (resendCounter === void 0) { resendCounter = 0; }
        return this.rejectResponsesTimeout[resendCounter]
            ? this.rejectResponsesTimeout[resendCounter]
            : this.rejectResponsesTimeout[this.rejectResponsesTimeout.length - 1];
    };
    RequestModule.prototype.sendRequest = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, jsonMessage, jobId, debugMsg, job;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connection = this.client.getConnection();
                        _a.label = 1;
                    case 1:
                        if (!!connection.isAuthenticated()) return [3, 3];
                        if (data.insertedAt && (data.insertedAt + data.msg.header.getTimeout() < Date.now())) {
                            data.reject(this.TimeoutErrorMessage);
                            return [2];
                        }
                        return [4, new Promise(function (resolve) { return setTimeout(function () { return resolve('Timeout reached'); }, 1000); })];
                    case 2:
                        _a.sent();
                        return [3, 1];
                    case 3:
                        data.msg.header.setIdApplication(connection.auth.idApplication);
                        data.msg.header.setIdUser(connection.auth.idUser);
                        jsonMessage = data.msg.getPtlMessage();
                        jobId = connection.send(jsonMessage).idJob;
                        data.msg.header.setJobId(jobId);
                        debugMsg = {
                            json: jsonMessage
                        };
                        if ((jsonMessage.Message === HighLevelRequest.NAME || jsonMessage.Message === HTTPProxyRequest.NAME) &&
                            typeof data.msg.getData === 'function') {
                            debugMsg.data = data.msg.getData();
                        }
                        job = {
                            msg: data.msg,
                            expirationTime: Date.now() + data.msg.header.getTimeout(),
                            resolve: data.resolve,
                            reject: data.reject,
                            request: debugMsg
                        };
                        this.jobs.set(jobId, job);
                        this.logger.trace("Sending " + jsonMessage.Message + " with idJob: " + jobId, debugMsg);
                        return [2];
                }
            });
        });
    };
    RequestModule.prototype.clearPendingRequests = function () {
        this.jobs.forEach(function (job, jobId) {
            var errorResponse = new ErrorResponse({
                Message: 'Foundation::ErrorResponse',
                header: {
                    id_job: jobId,
                    id_service: '0'
                },
                reason: {
                    value: 1001
                }
            });
            job.reject(errorResponse);
        });
        this.jobs.clear();
    };
    RequestModule.supportedPermissionDeniedResponseMessages = function (msg) {
        var supportedMessages = [
            NotationFieldValueRequest,
            InstrumentFieldValueRequest,
            PrioritizedNotationFieldValueRequest,
            PrioritizedInstrumentFieldValueRequest,
            HighLevelRequest
        ];
        for (var _i = 0, supportedMessages_1 = supportedMessages; _i < supportedMessages_1.length; _i++) {
            var supportedMessage = supportedMessages_1[_i];
            if (msg instanceof supportedMessage) {
                return true;
            }
        }
        return false;
    };
    return RequestModule;
}());
export { RequestModule };
//# sourceMappingURL=RequestModule.js.map